
import React from 'react';
import { DisplayedImage } from '../types'; 

interface StorePageProps {
  imageForStore: DisplayedImage;
  onBackToStudio: () => void;
}

const StorePage: React.FC<StorePageProps> = ({ imageForStore, onBackToStudio }) => {
  const products = [
    { name: "Camiseta Premium", price: "29.99€", mockupClass: "bg-white h-40 w-32 flex items-center justify-center rounded border border-gray-300" },
    { name: "Taza de Café", price: "15.99€", mockupClass: "bg-white h-32 w-32 flex items-center justify-center rounded-full border border-gray-300" },
    { name: "Póster Artístico (A3)", price: "24.99€", mockupClass: "bg-white h-48 w-36 flex items-center justify-center rounded border border-gray-300 shadow-lg" },
    { name: "Funda de Móvil", price: "19.99€", mockupClass: "bg-gray-200 h-36 w-20 flex items-center justify-center rounded-lg border border-gray-400" }
  ];

  // Defensive check for imageForStore and its essential properties
  if (!imageForStore || !imageForStore.url || !imageForStore.alt) {
    return (
      <div className="flex-1 flex flex-col items-center justify-center p-4 sm:p-8 bg-gray-800 text-gray-100">
        <p className="text-xl text-red-400">Error: No se pudo cargar la imagen para la tienda.</p>
        <p className="text-sm text-gray-400 mt-2">Por favor, intenta seleccionar otra imagen.</p>
        <button
          onClick={onBackToStudio}
          className="mt-6 px-8 py-3 bg-indigo-600 hover:bg-indigo-700 text-white font-semibold rounded-lg"
        >
          Volver al Estudio
        </button>
      </div>
    );
  }

  return (
    <div className="flex-1 flex flex-col items-center justify-start p-4 sm:p-8 bg-gray-800 text-gray-100 overflow-y-auto">
      <div className="w-full max-w-5xl">
        <header className="mb-8 text-center">
          <h1 className="text-4xl sm:text-5xl font-bold text-yellow-400 mb-2">
            Tienda de ArteAI
          </h1>
          <p className="text-lg text-gray-300">
            ¡Lleva tu creación al mundo real! (Demostración)
          </p>
        </header>

        <div className="mb-8 p-4 bg-gray-700 rounded-lg shadow-xl flex flex-col md:flex-row items-center md:items-start">
          <div className="md:w-1/2 p-4 flex justify-center">
            <img
              src={imageForStore.url}
              alt={`Arte: ${imageForStore.alt}`}
              className="max-w-full max-h-[50vh] object-contain rounded-md shadow-lg border-2 border-yellow-500"
            />
          </div>
          <div className="md:w-1/2 p-4 text-gray-200">
            <h2 className="text-2xl font-semibold mb-2 text-yellow-300">Tu Obra Seleccionada</h2>
            <p className="text-lg mb-1"><strong>Título:</strong> {imageForStore.alt}</p>
            {imageForStore.promptUsed && (
              <p className="text-sm mb-1">
                <strong>Prompt:</strong> <em className="text-gray-400">"{imageForStore.promptUsed.substring(0,100)}{imageForStore.promptUsed.length > 100 ? '...' : ''}"</em>
              </p>
            )}
            {imageForStore.appliedEdit && (
                <p className="text-sm mb-1"><strong>Edición:</strong> {imageForStore.appliedEdit}</p>
            )}
            <p className="mt-4 text-sm text-gray-400">
              Imagina esta obra en productos únicos. ¡Explora las posibilidades!
            </p>
          </div>
        </div>

        <section className="mb-8">
          <h3 className="text-2xl font-semibold text-gray-200 mb-6 text-center">Productos Destacados</h3>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
            {products.map(product => (
              <div key={product.name} className="bg-gray-700 p-4 rounded-lg shadow-md hover:shadow-xl transition-shadow">
                <div className={`${product.mockupClass} mb-3 mx-auto relative overflow-hidden`}>
                  <img
                    src={imageForStore.url}
                    alt={`${product.name} con ${imageForStore.alt}`}
                    className="absolute inset-0 w-full h-full object-cover opacity-80" 
                  />
                   <span className="relative z-10 p-2 bg-black bg-opacity-30 text-white text-xs rounded">Tu Imagen Aquí</span>
                </div>
                <h4 className="text-lg font-medium text-yellow-300">{product.name}</h4>
                <p className="text-xl text-gray-100 mb-2">{product.price}</p>
                <button className="w-full mt-2 px-4 py-2 bg-yellow-500 hover:bg-yellow-600 text-black font-semibold rounded-md transition duration-150 ease-in-out focus:outline-none focus:ring-2 focus:ring-yellow-400 disabled:opacity-50" disabled>
                  Añadir al Carrito (Próximamente)
                </button>
              </div>
            ))}
          </div>
        </section>

        <div className="text-center mt-10">
          <button
            onClick={onBackToStudio}
            className="px-8 py-3 bg-indigo-600 hover:bg-indigo-700 text-white font-semibold rounded-lg shadow-md transition-colors duration-150 ease-in-out focus:outline-none focus:ring-2 focus:ring-indigo-400 focus:ring-offset-2 focus:ring-offset-gray-800"
          >
            Volver al Estudio
          </button>
        </div>
      </div>
    </div>
  );
};

export default StorePage;
